import ArgType from 'notebook/tables/excess/ArgType';
import FunctionCategory from 'notebook/tables/excess/FunctionCategory';
import {EvaluablePrimitiveSpreadsheetFunction} from 'notebook/tables/excess/FunctionConstants';

export default {
  name: 'EXP',
  category: FunctionCategory.MATH,
  shortDescription: 'Returns e raised to the power of a number.',
  description:
    'Returns e raised to the power of a number. The constant e equals 2.71828182845904, the base of the natural logarithm. EXP is the inverse of LN, the natural logarithm of number.',
  params: [
    {
      name: 'number',
      type: ArgType.number,
      description: 'The exponent applied to the base e.',
    },
  ],
  eval: (value: number): number => Math.exp(value),
} satisfies EvaluablePrimitiveSpreadsheetFunction;
